import React from "react";
import { useTranslation } from "hhn-commons";
import { InputField } from "./InputFields.style";

type InputGroupNameProps = {
  value: string;
  onNameChange: (key: string, value: string) => void;
  isError: boolean;
  setIsError: (isError: boolean) => void;
};

const InputGroupName = ({
  value,
  onNameChange,
  isError,
  setIsError,
}: InputGroupNameProps) => {
  const { t } = useTranslation();
  const tNs = (key: string) => t(key, { ns: "internalGroup" });

  return (
    <InputField
      required
      fullWidth
      id="outlined-basic"
      label={tNs("nameLabel")}
      variant="outlined"
      value={value ?? ""}
      error={isError}
      slotProps={{
        htmlInput: {
          "data-testid": "group name",
          maxLength: 25,
        },
      }}
      onBlur={e => {
        setIsError(e.target.value.trim().length <= 0);
      }}
      helperText={isError && tNs("nameError")}
      onChange={event => {
        onNameChange("groupName", event.target.value);
        setIsError(event.target.value.trim().length <= 0);
      }}
      sx={{ mt: 3 }}
    />
  );
};

export default InputGroupName;
